import React, { useState, useEffect } from "react";
import moment from "moment";
import { message } from "../../../Reducers/loading/actions";
import { useDispatch } from "react-redux";
const FilterSensor = ({ loading, gemiddelde, max, verbruik, gastverbruik }) => {
  const [gemiddeldeState, setGemiddeldeState] = useState(0);
  const [verbruikState, setVerbruikState] = useState(0);
  const [maxState, setMaxState] = useState(0);

  const [voorschot, setVoorschot] = useState(0);
  const [verblijftijd, setVerblijftijd] = useState(0);
  const dispatch = useDispatch();
  useEffect(() => {
    if (!loading) {
      setGemiddeldeState(gemiddelde.toFixed(2));
      if (gastverbruik.meterstandvertrek) {
        setVerbruikState((gastverbruik.meterstandvertrek - gastverbruik.meterstanndaankomst).toFixed(2));
      } else {
        setVerbruikState((gastverbruik.standplaats.device.lastvalue - gastverbruik.meterstanndaankomst).toFixed(2));
      }
      berekenverblijdtijd();
      if (verbruik > 0) {
        dispatch(message(3000, "success", "Sensor gegevens succesvol geladen"));
      } else {
        dispatch(message(6000, "warning", "Er zijn geen gegevens gevonden voor deze periode"));
      }
      setVoorschot(gastverbruik.kwh ? gastverbruik.kwh : Number(verblijftijd * Number(gastverbruik.standplaats.categorie.voorschot)).toFixed(2));
    }
  }, [gemiddelde, max, verbruik, voorschot, verblijftijd]);

  const berekenverblijdtijd = () => {
    if (moment(gastverbruik.vertrek).isBefore(moment())) {
      setVerblijftijd(
        moment
          .duration(moment(gastverbruik.vertrek).diff(moment(gastverbruik.aankomst)))
          .asDays()
          .toFixed(0)
      );
    } else {
      setVerblijftijd(
        moment
          .duration(moment(new Date()).diff(moment(gastverbruik.aankomst)))
          .asDays()
          .toFixed(0)
      );
    }
  };
  const verschil = () => {
    if (voorschot - verbruikState < 0) {
      return <span className="badge badge-danger">{(voorschot - verbruikState).toFixed(2)} kWh</span>;
    } else {
      return <span className="badge badge-success">{(voorschot - verbruikState).toFixed(2)} kWh</span>;
    }
  };

  const totaalBetaald = () => {
    return gastverbruik.boekingsregels.reduce((total, regel) => {
      // parseFloat zet "9.60" om naar 9.6; als parseFloat faalt gebruiken we 0
      const prijsNum = parseFloat(regel.prijs) || 0;
      return (total + prijsNum).toFixed(2);
    }, 0);
  };

  const betaling = () => {
    if (voorschot - verbruikState < 0) {
      return <span className="badge badge-danger">€ {Number((voorschot - verbruikState) * gastverbruik.gast.gastenprofiel.prijs).toFixed(2)}</span>;
    } else {
      return <span className="badge badge-success">€ {Number((voorschot - verbruikState) * gastverbruik.gast.gastenprofiel.prijs).toFixed(2)}</span>;
    }
  };

  return (
    <div className="row container filter">
      <div className="col-md-2 col-sm-6 col-xs-6">
        Totaal Verbruik<span className="gemiddelde">{verbruikState} kWh</span>
      </div>
      <div className="col-md-2 col-sm-6 col-xs-6">
        Totale voorschot<span className="gemiddelde">{voorschot} kWh</span>
      </div>
      <div className="col-md-2 col-sm-6 col-xs-6">
        {voorschot - verbruikState < 0 ? "Verrekening" : "Tegoed"} <span className="gemiddelde">{verschil()}</span>
      </div>
      <div className="col-md-2 col-sm-6 col-xs-6">
        Tegoed <span className="gemiddelde">{betaling()}</span>
      </div>
      {gemiddeldeState > 0 ? (
        <div className="col-md-2 col-sm-6 col-xs-6">
          Gemiddelde (per dag)<span className="gemiddelde">{gemiddeldeState} kWh</span>
        </div>
      ) : (
        <div className="col-md-2 col-sm-6 col-xs-6">
          Gemiddelde (per dag)<span className="gemiddelde">-</span>
        </div>
      )}
    </div>
  );
};

export default FilterSensor;
